/* Atsteps country-aware EU / UK / US size switcher. Uses Shopify's original radio values. */
(function(){
  'use strict';
  var UNITS={EU:1,UK:1,US:1};
  function formatSelected(fieldset,unit) {
    var checked=fieldset.querySelector('input[type="radio"]:checked');
    if (!checked || !checked.id) return;
    var radios=fieldset.querySelectorAll('input[type="radio"]');
    var label=null;
    for(var i=0;i<radios.length;i++){
      if(radios[i]===checked){
        var candidates=fieldset.querySelectorAll('label[for]');
        for(var j=0;j<candidates.length;j++){
          if(candidates[j].getAttribute('for')===checked.id){label=candidates[j];break}
        }
        break;
      }
    }
    var sizeLabel=label && label.querySelector('.atsteps-size-text');
    var heading=fieldset.querySelector('.form__label .option_value');
    if(heading && sizeLabel && sizeLabel.dataset[unit.toLowerCase()]){
      var wanted=sizeLabel.dataset[unit.toLowerCase()];
      if(heading.textContent.trim()!==wanted) heading.textContent=wanted;
    }
  }
  function apply(fieldset,unit) {
    if(!fieldset || !UNITS[unit])return;
    fieldset.dataset.atstepsUnit=unit;
    var grid=fieldset.querySelector('.atsteps-size-grid');
    if(grid)grid.style.setProperty('grid-template-columns','repeat(5,minmax(0,1fr))','important');
    var buttons=fieldset.querySelectorAll('.atsteps-size-tabs__button');
    buttons.forEach(function(button){
      var active=button.dataset.unit===unit;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
      button.style.setProperty('background-color',active?'#fff':'transparent','important');
      button.style.setProperty('color',active?'#111':'#777','important');
      button.style.setProperty('border-color',active?'#d7d7d7':'transparent','important');
      button.style.setProperty('box-shadow',active?'0 1px 4px rgba(0,0,0,.08)':'none','important');
    });
    fieldset.querySelectorAll('.atsteps-size-text').forEach(function(label){
      var value=label.dataset[unit.toLowerCase()];
      if(!value)return;
      // Display US pairs compactly to ensure one line, while retaining original Shopify variant values.
      var displayed=unit==='US'?value.replace(/\s*\/\s*/g,'/'):value;
      if(label.textContent.trim()!==displayed)label.textContent=displayed;
      if(unit==='US'){
        label.style.setProperty('white-space','nowrap','important');
        label.style.setProperty('display','block','important');
        label.style.setProperty('width','max-content','important');
        label.style.setProperty('max-width','none','important');
        label.style.setProperty('font-size','15px','important');
        label.style.setProperty('letter-spacing','-0.35px','important');
        var tile=label.closest('label.product__item-option');
        if(tile){
          tile.style.setProperty('font-size','15px','important');
          tile.style.setProperty('white-space','nowrap','important');
          tile.style.setProperty('justify-content','center','important');
          tile.style.setProperty('align-items','center','important');
        }
      }else{
        label.style.removeProperty('white-space');
        label.style.removeProperty('width');
        label.style.removeProperty('max-width');
        label.style.removeProperty('font-size');
        label.style.removeProperty('letter-spacing');
        label.style.removeProperty('display');
        var tile=label.closest('label.product__item-option');
        if(tile){tile.style.removeProperty('font-size');tile.style.removeProperty('white-space');}
      }
    });
    formatSelected(fieldset,unit);
    if(unit==='US'){
      var adjust=function(){
        /* Keep one readable font size across all five equal US size cards. */
        var labels=Array.prototype.slice.call(fieldset.querySelectorAll('.g-size-grid .g-size-btn-label'));
        var fitted=15;
        labels.forEach(function(label){
          var tile=label.closest('label.g-size-btn');
          label.style.setProperty('font-size','15px','important');
          if(tile)tile.style.setProperty('font-size','15px','important');
        });
        labels.forEach(function(label){
          var tile=label.closest('label.g-size-btn');
          if(!tile)return;
          var available=tile.getBoundingClientRect().width-6;
          var needed=label.getBoundingClientRect().width;
          if(available>0 && needed>available){
            fitted=Math.min(fitted,Math.floor((15*available/needed)*10)/10);
          }
        });
        fitted=Math.max(8,Math.min(15,fitted));
        labels.forEach(function(label){
          var tile=label.closest('label.g-size-btn');
          label.style.setProperty('font-size',fitted+'px','important');
          if(tile)tile.style.setProperty('font-size',fitted+'px','important');
        });
      };
      if(window.requestAnimationFrame)window.requestAnimationFrame(adjust);
      else adjust();
    }
  }
  document.addEventListener('click',function(e){
    var target=e.target.closest && e.target.closest('.atsteps-size-tabs__button');
    if(!target)return;
    var fieldset=target.closest('fieldset[data-atsteps-size-picker]');
    if(fieldset)apply(fieldset,target.dataset.unit);
  });
  document.addEventListener('change',function(e){
    var target=e.target;
    if(!target || !target.matches('fieldset[data-atsteps-size-picker] input[type="radio"]'))return;
    var fieldset=target.closest('fieldset[data-atsteps-size-picker]');
    if(fieldset)window.setTimeout(function(){apply(fieldset,fieldset.dataset.atstepsUnit||'EU')},0);
  },true);
  document.addEventListener('shopify:section:load',function(e){
    e.target.querySelectorAll('fieldset[data-atsteps-size-picker]').forEach(function(fieldset){
      apply(fieldset,fieldset.dataset.atstepsUnit||'EU');
    });
  });
  function syncCurrentSizeUnit(){
    document.querySelectorAll('fieldset[data-atsteps-size-picker="true"]').forEach(function(fieldset){
      var unit=fieldset.dataset.atstepsUnit||'EU';
      if(UNITS[unit])apply(fieldset,unit);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',syncCurrentSizeUnit);
  else syncCurrentSizeUnit();
  /* Shopify's editor and device rotation can change the size grid width. */
  var sizeResizeQueued=false;
  window.addEventListener('resize',function(){
    if(sizeResizeQueued)return;
    sizeResizeQueued=true;
    window.requestAnimationFrame(function(){
      sizeResizeQueued=false;
      syncCurrentSizeUnit();
    });
  },{passive:true});
})();
/* The guide uses the SAME size values rendered by Shopify, not an independent conversion table. */
document.addEventListener('click', function(event){
  var trigger=event.target.closest && event.target.closest('.atsteps-size-guide-trigger');
  if(!trigger)return;
  var fieldset=trigger.closest('fieldset[data-atsteps-size-picker="true"]');
  if(!fieldset)return;
  var panel=fieldset.querySelector('.atsteps-size-guide-panel');
  if(!panel)return;
  var opening=panel.hidden;
  if(opening&&!panel.dataset.atstepsFilled){
    var body=panel.querySelector('tbody');
    if(body){
      fieldset.querySelectorAll('.atsteps-size-grid .atsteps-size-text').forEach(function(label){
        var row=document.createElement('tr');
        ['eu','uk','usWomen','usMen'].forEach(function(unit){
          var td=document.createElement('td');
          td.textContent=label.dataset[unit]||'—';
          row.appendChild(td);
        });
        body.appendChild(row);
      });
    }
    panel.dataset.atstepsFilled='true';
  }
  panel.hidden=!opening;
  trigger.setAttribute('aria-expanded',String(opening));
});
